// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditWishListGroup-space1-DtqKP {
	margin-bottom: 6px !important;
}

.EditWishListGroup-space2-mrlOw {
	margin-bottom: 12px !important;
}

.EditWishListGroup-space3-h9cwM {
	margin-bottom: 18px !important;
}

.EditWishListGroup-space4-SKaj7 {
	margin-bottom: 24px !important;
}

.EditWishListGroup-space5-_Qpz2 {
	margin-bottom: 30px !important;
}

.EditWishListGroup-space6-rQden {
	margin-bottom: 36px !important;
}

.EditWishListGroup-space7-MDFsZ {
	margin-bottom: 42px !important;
}

.EditWishListGroup-spaceTop8-LQaWZ {
	margin-bottom: 48px !important;
}

.EditWishListGroup-spaceTop1-WCJfX {
	margin-top: 6px !important;
}

.EditWishListGroup-spaceTop2-piuVG {
	margin-top: 12px !important;
}

.EditWishListGroup-spaceTop3-fq3Dp {
	margin-top: 18px !important;
}

.EditWishListGroup-spaceTop4-xkFuO {
	margin-top: 24px !important;
}

.EditWishListGroup-spaceTop5-_Qup2 {
	margin-top: 30px !important;
}

.EditWishListGroup-spaceTop6-nBymW {
	margin-top: 36px !important;
}

.EditWishListGroup-spaceTop7-z2TQt {
	margin-top: 42px !important;
}

.EditWishListGroup-spaceTop8-LQaWZ {
	margin-top: 48px !important;
}

.EditWishListGroup-noMargin-JWsUn {
	margin: 0px !important;
}

.EditWishListGroup-padding1-jP3Q6 {
	padding-bottom: 6px !important;
}

.EditWishListGroup-padding2-NHe4T {
	padding-bottom: 12px !important;
}

.EditWishListGroup-padding3-DWVMp {
	padding-bottom: 18px !important;
}

.EditWishListGroup-padding4-wTdWm {
	padding-bottom: 24px !important;
}

.EditWishListGroup-padding5-JKeBc {
	padding-bottom: 30px !important;
}

.EditWishListGroup-padding6-P4VHu {
	padding-bottom: 36px !important;
}

.EditWishListGroup-padding7-Y1ifx {
	padding-bottom: 42px !important;
}

.EditWishListGroup-paddingTop1-dsV33 {
	padding-top: 6px !important;
}

.EditWishListGroup-paddingTop2-NuP4I {
	padding-top: 12px !important;
}

.EditWishListGroup-paddingTop3-oJJdw {
	padding-top: 18px !important;
}

.EditWishListGroup-paddingTop4-nWVzf {
	padding-top: 24px !important;
}

.EditWishListGroup-paddingTop5-_3Mmy {
	padding-top: 30px !important;
}

.EditWishListGroup-paddingTop6-DqM2B {
	padding-top: 36px !important;
}

.EditWishListGroup-paddingTop7-Eufud {
	padding-top: 42px !important;
}

.EditWishListGroup-noPadding-hVbhQ {
	padding: 0px !important;
}

.EditWishListGroup-textBold-oNXok {
	font-weight: 500 !important;
}

.EditWishListGroup-textBolder-gH5Tv {
	font-weight: 700 !important;
}

.EditWishListGroup-textNormal-_tZa8 {
	font-weight: normal !important;
}

.EditWishListGroup-spaceBottom20-CyNhc {
	margin-bottom: 20px;
}

.EditWishListGroup-spaceBottom10-Vq9HZ {
	margin-bottom: 10px;
}

.EditWishListGroup-marginNone-Hf9cl {
	margin: 0;
}

.EditWishListGroup-spaceBottom15-AJOT0 {
	margin-bottom: 15px;
}

.EditWishListGroup-marginTopNone-IlIdP {
	margin-top: 0;
}

.EditWishListGroup-spaceTop11-zIxHB {
	margin-top: 11px;
}

.EditWishListGroup-spaceTop21-Z7jhR {
	margin-top: 21px;
}

.EditWishListGroup-spaceTop20-n2fZY {
	margin-top: 20px;
}

.EditWishListGroup-spaceTop10-Dg5ss {
	margin-top: 10px;
}

/*New Design Text Colors */

.EditWishListGroup-textDarkBlue-ZO7Ht {
	color: rgb(20, 39, 94) !important;
}

.EditWishListGroup-textLightBlue-BXWdx {
	color: rgb(57, 87, 106) !important;
}

.EditWishListGroup-textLightSandleGreen-NB4nc {
	color: rgb(76, 86, 41) !important;
}

.EditWishListGroup-textLightBrown-u91MB {
	color: rgb(115, 79, 33) !important;
}

.EditWishListGroup-textMediumMaroon-ih0Ee {
	color: rgb(87, 37, 51) !important;
}

.EditWishListGroup-textBrown-GmLAg {
	color: rgb(160, 47, 24) !important;
}

.EditWishListGroup-textMaroon-opt6m {
	color: rgb(155, 49, 67) !important;
}

.EditWishListGroup-textDarkBrown-uXdrS {
	color: rgb(83, 18, 16) !important;
}

.EditWishListGroup-textMediumBrown-zElvJ {
	color: rgb(142, 28, 10) !important;
}

.EditWishListGroup-textSkyBlue-Mmd7g {
	color: rgb(37, 117, 141) !important;
}

.EditWishListGroup-textGray-PvjB7 {
	color: rgb(77, 65, 51) !important;
}

.EditWishListGroup-button-nYJ6J {
	font-size: 18px !important;
	line-height: 1.42857143;
	border: 1px solid;
	text-decoration: none !important;
	display: inline-block;
	text-align: center;
}

.EditWishListGroup-deleteBtnMargin-CzDJA {
	margin-right: 0px !important;
}

.EditWishListGroup-landingTitle-hgx2K {
	font-size: 32px;
	margin: 42px 0px 22px 0px;
	word-break: break-word;
}

.EditWishListGroup-landingContentTitle-d_X_O {
	font-size: 24px;
	margin: 0px 0px 18px 0px;
}

.EditWishListGroup-landingContent-YHgF6 {
	margin-bottom: 100px;
}

.EditWishListGroup-pullRight-jN1Vd {
	float: right;
}

.EditWishListGroup-noPadding-hVbhQ {
	padding: 0px;
}

.EditWishListGroup-landingContentTitle-d_X_O {
	font-size: 24px;
	margin: 0px 0px 18px 0px;
}

.EditWishListGroup-marginTop-zwcSf {
	margin-top: 40px !important;
}

.EditWishListGroup-listingSection-TqXDY {
	display: inline-block;
	width: 25%;
	padding: 0px 8px;
	margin-bottom: 12px;
}

.EditWishListGroup-resposiveBtn-wAwyY {
	color: var(--primary-link-foreground) !important;
	background-color: transparent !important;
	border: inherit !important;
	padding: 0px !important;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}

.EditWishListGroup-iconCss-IPf3O {
	margin-right: 4px;
	position: relative;
	top: -2px;
}

.EditWishListGroup-errorCss-jghP1 {
	font-size: 18px;
	margin-bottom: 22px;
}

.EditWishListGroup-displayInlineBlock-VUn2C {
	display: inline-block;
}

.EditWishListGroup-textRight-Ap5Iq {
	text-align: right;
}

.EditWishListGroup-wishFlex-CR0v8 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.EditWishListGroup-textDecoration-_HZkC {
	text-decoration: underline;
}

.EditWishListGroup-btnFlex-tAvar {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 15px;
	   -moz-column-gap: 15px;
	        column-gap: 15px;
}

.EditWishListGroup-goToALLText-xPH95 {
	font-size: 18px !important;
	text-decoration: underline !important;
}

@media (max-width: 1023px) and (min-width: 768px) {
	.EditWishListGroup-listingSection-TqXDY {
		display: inline-block;
		width: 33.33%;
		padding: 0px 8px;
		margin-bottom: 12px;
	}
}

@media (max-width: 991px) and (min-width: 768px) {
	.EditWishListGroup-displayInlineBlock-VUn2C {
		display: inline-block;
		vertical-align: middle;
	}

	.EditWishListGroup-pullRghtNone-Y_X35 {
		float: none;
	}
}

@media screen and (max-width: 767px) {
	.EditWishListGroup-listingSection-TqXDY {
		display: inline-block;
		width: 100%;
		padding: 0px 0px 12px 0px;
		margin-bottom: 0px;
	}

	.EditWishListGroup-resposiveBtn-wAwyY {
		width: 100%;
		text-align: center;
	}

	.EditWishListGroup-responsiveDeleteBtn-YYR13 {
		margin-right: 0;
		margin-top: 12px;
	}

	.EditWishListGroup-wishFlex-CR0v8 {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		row-gap: 10px;
	}

	.EditWishListGroup-btnFlex-tAvar {
		text-align: left;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}
}

@media screen and (max-width: 600px) {
	.EditWishListGroup-modalCaptionLinkLarge-E5Z4h {
		padding-left: 8px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/WishLists/EditWishListGroup/EditWishListGroup.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,0BAA0B;CAC1B,uBAAuB;CACvB,iBAAiB;CACjB,gCAAgC;CAChC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gDAAgD;CAChD,wCAAwC;CACxC,0BAA0B;CAC1B,uBAAuB;CACvB,sCAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,qCAAqC;AACtC;;AAEA;CACC;EACC,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,mBAAe;MAAf,eAAe;EACf,aAAa;CACd;;CAEA;EACC,gBAAgB;EAChB,mBAAe;MAAf,eAAe;EACf,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../helpers.css';\n\n.button {\n\tfont-size: 18px !important;\n\tline-height: 1.42857143;\n\tborder: 1px solid;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\ttext-align: center;\n}\n\n.deleteBtnMargin {\n\tmargin-right: 0px !important;\n}\n\n.landingTitle {\n\tfont-size: 32px;\n\tmargin: 42px 0px 22px 0px;\n\tword-break: break-word;\n}\n\n.landingContentTitle {\n\tfont-size: 24px;\n\tmargin: 0px 0px 18px 0px;\n}\n\n.landingContent {\n\tmargin-bottom: 100px;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.landingContentTitle {\n\tfont-size: 24px;\n\tmargin: 0px 0px 18px 0px;\n}\n\n.marginTop {\n\tmargin-top: 40px !important;\n}\n\n.listingSection {\n\tdisplay: inline-block;\n\twidth: 25%;\n\tpadding: 0px 8px;\n\tmargin-bottom: 12px;\n}\n\n.resposiveBtn {\n\tcolor: var(--primary-link-foreground) !important;\n\tbackground-color: transparent !important;\n\tborder: inherit !important;\n\tpadding: 0px !important;\n\tbox-shadow: inherit !important;\n}\n\n.iconCss {\n\tmargin-right: 4px;\n\tposition: relative;\n\ttop: -2px;\n}\n\n.errorCss {\n\tfont-size: 18px;\n\tmargin-bottom: 22px;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.wishFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.textDecoration {\n\ttext-decoration: underline;\n}\n\n.btnFlex {\n\tdisplay: flex;\n\tcolumn-gap: 15px;\n}\n\n.goToALLText {\n\tfont-size: 18px !important;\n\ttext-decoration: underline !important;\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.listingSection {\n\t\tdisplay: inline-block;\n\t\twidth: 33.33%;\n\t\tpadding: 0px 8px;\n\t\tmargin-bottom: 12px;\n\t}\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n\t.displayInlineBlock {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n\n\t.pullRghtNone {\n\t\tfloat: none;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.listingSection {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t\tpadding: 0px 0px 12px 0px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\t.resposiveBtn {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.responsiveDeleteBtn {\n\t\tmargin-right: 0;\n\t\tmargin-top: 12px;\n\t}\n\n\t.wishFlex {\n\t\tflex-wrap: wrap;\n\t\trow-gap: 10px;\n\t}\n\n\t.btnFlex {\n\t\ttext-align: left;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: space-between;\n\t}\n}\n\n@media screen and (max-width: 600px) {\n\t.modalCaptionLinkLarge {\n\t\tpadding-left: 8px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EditWishListGroup-space1-DtqKP`,
	"space2": `EditWishListGroup-space2-mrlOw`,
	"space3": `EditWishListGroup-space3-h9cwM`,
	"space4": `EditWishListGroup-space4-SKaj7`,
	"space5": `EditWishListGroup-space5-_Qpz2`,
	"space6": `EditWishListGroup-space6-rQden`,
	"space7": `EditWishListGroup-space7-MDFsZ`,
	"spaceTop8": `EditWishListGroup-spaceTop8-LQaWZ`,
	"spaceTop1": `EditWishListGroup-spaceTop1-WCJfX`,
	"spaceTop2": `EditWishListGroup-spaceTop2-piuVG`,
	"spaceTop3": `EditWishListGroup-spaceTop3-fq3Dp`,
	"spaceTop4": `EditWishListGroup-spaceTop4-xkFuO`,
	"spaceTop5": `EditWishListGroup-spaceTop5-_Qup2`,
	"spaceTop6": `EditWishListGroup-spaceTop6-nBymW`,
	"spaceTop7": `EditWishListGroup-spaceTop7-z2TQt`,
	"noMargin": `EditWishListGroup-noMargin-JWsUn`,
	"padding1": `EditWishListGroup-padding1-jP3Q6`,
	"padding2": `EditWishListGroup-padding2-NHe4T`,
	"padding3": `EditWishListGroup-padding3-DWVMp`,
	"padding4": `EditWishListGroup-padding4-wTdWm`,
	"padding5": `EditWishListGroup-padding5-JKeBc`,
	"padding6": `EditWishListGroup-padding6-P4VHu`,
	"padding7": `EditWishListGroup-padding7-Y1ifx`,
	"paddingTop1": `EditWishListGroup-paddingTop1-dsV33`,
	"paddingTop2": `EditWishListGroup-paddingTop2-NuP4I`,
	"paddingTop3": `EditWishListGroup-paddingTop3-oJJdw`,
	"paddingTop4": `EditWishListGroup-paddingTop4-nWVzf`,
	"paddingTop5": `EditWishListGroup-paddingTop5-_3Mmy`,
	"paddingTop6": `EditWishListGroup-paddingTop6-DqM2B`,
	"paddingTop7": `EditWishListGroup-paddingTop7-Eufud`,
	"noPadding": `EditWishListGroup-noPadding-hVbhQ`,
	"textBold": `EditWishListGroup-textBold-oNXok`,
	"textBolder": `EditWishListGroup-textBolder-gH5Tv`,
	"textNormal": `EditWishListGroup-textNormal-_tZa8`,
	"spaceBottom20": `EditWishListGroup-spaceBottom20-CyNhc`,
	"spaceBottom10": `EditWishListGroup-spaceBottom10-Vq9HZ`,
	"marginNone": `EditWishListGroup-marginNone-Hf9cl`,
	"spaceBottom15": `EditWishListGroup-spaceBottom15-AJOT0`,
	"marginTopNone": `EditWishListGroup-marginTopNone-IlIdP`,
	"spaceTop11": `EditWishListGroup-spaceTop11-zIxHB`,
	"spaceTop21": `EditWishListGroup-spaceTop21-Z7jhR`,
	"spaceTop20": `EditWishListGroup-spaceTop20-n2fZY`,
	"spaceTop10": `EditWishListGroup-spaceTop10-Dg5ss`,
	"textDarkBlue": `EditWishListGroup-textDarkBlue-ZO7Ht`,
	"textLightBlue": `EditWishListGroup-textLightBlue-BXWdx`,
	"textLightSandleGreen": `EditWishListGroup-textLightSandleGreen-NB4nc`,
	"textLightBrown": `EditWishListGroup-textLightBrown-u91MB`,
	"textMediumMaroon": `EditWishListGroup-textMediumMaroon-ih0Ee`,
	"textBrown": `EditWishListGroup-textBrown-GmLAg`,
	"textMaroon": `EditWishListGroup-textMaroon-opt6m`,
	"textDarkBrown": `EditWishListGroup-textDarkBrown-uXdrS`,
	"textMediumBrown": `EditWishListGroup-textMediumBrown-zElvJ`,
	"textSkyBlue": `EditWishListGroup-textSkyBlue-Mmd7g`,
	"textGray": `EditWishListGroup-textGray-PvjB7`,
	"button": `EditWishListGroup-button-nYJ6J`,
	"deleteBtnMargin": `EditWishListGroup-deleteBtnMargin-CzDJA`,
	"landingTitle": `EditWishListGroup-landingTitle-hgx2K`,
	"landingContentTitle": `EditWishListGroup-landingContentTitle-d_X_O`,
	"landingContent": `EditWishListGroup-landingContent-YHgF6`,
	"pullRight": `EditWishListGroup-pullRight-jN1Vd`,
	"marginTop": `EditWishListGroup-marginTop-zwcSf`,
	"listingSection": `EditWishListGroup-listingSection-TqXDY`,
	"resposiveBtn": `EditWishListGroup-resposiveBtn-wAwyY`,
	"iconCss": `EditWishListGroup-iconCss-IPf3O`,
	"errorCss": `EditWishListGroup-errorCss-jghP1`,
	"displayInlineBlock": `EditWishListGroup-displayInlineBlock-VUn2C`,
	"textRight": `EditWishListGroup-textRight-Ap5Iq`,
	"wishFlex": `EditWishListGroup-wishFlex-CR0v8`,
	"textDecoration": `EditWishListGroup-textDecoration-_HZkC`,
	"btnFlex": `EditWishListGroup-btnFlex-tAvar`,
	"goToALLText": `EditWishListGroup-goToALLText-xPH95`,
	"pullRghtNone": `EditWishListGroup-pullRghtNone-Y_X35`,
	"responsiveDeleteBtn": `EditWishListGroup-responsiveDeleteBtn-YYR13`,
	"modalCaptionLinkLarge": `EditWishListGroup-modalCaptionLinkLarge-E5Z4h`
};
module.exports = ___CSS_LOADER_EXPORT___;
